import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, title: String, text: String }

  connect() {
    if (navigator.share) {
      this.element.classList.remove("hidden")
    }
  }

  share() {
    if (navigator.share) {
      navigator.share({
        title: this.titleValue || "CatchHook Endpoint",
        text: this.textValue || "",
        url: this.urlValue,
      }).catch(() => {})
    }
  }
}
